export class AuthenticationRequest {
  constructor (email, password) {
    this.email = email
    this.password = password
  }
}
